<template>
  <footer class="section" id="page-footer">
    <div class="wrap">
      <b-row class="mt-5 mb-4">
        <div class="bloco-intes">
          <div class="itens-footer">
            <a
              class="text-center"
              style="text-decoration: none"
              target="_blank"
              href="https://maps.app.goo.gl/mn87pp6HNnetoR2GA"
            >
              <b-icon icon="building"></b-icon>
              <p>Av. Faria Lima, 1811 - SP</p>
            </a>
          </div>
          <div class="itens-footer">
            <a
              class="text-center"
              style="text-decoration: none"
              href="tel:551137917204"
            >
              <b-icon icon="telephone-fill"></b-icon>
              <p>(11) 3791-7204</p>
            </a>
          </div>
          <div class="itens-footer email">
            <!-- <a
              @click="openForm()"
              v-scroll-to="'#scrollhere'"
              class="text-center"
              style="text-decoration: none"
            >
              <b-icon icon="envelope-fill"></b-icon>
              <p>Contato</p>
            </a> -->
            <a
              class="text-center"
              style="text-decoration: none"
              href="mailto:contato@encinterativa.com.br?subject=Contato%20-%20ENC%20Interativa&body=Ol%C3%A1%2C%20gostaria%20de%20obter%20mais%20informa%C3%A7%C3%B5es%20sobre%20os%20servi%C3%A7os%20da%20ENC%20Interativa.%0D%0A%0D%0ANome%3A%0D%0AEmpresa%3A%0D%0ATelefone%3A%0D%0A%0D%0AMensagem%3A"
            >
              <b-icon icon="envelope-fill"></b-icon>
              <p>contato@encinterativa.com.br</p>
            </a>
          </div>
        </div>
        <!-- <form
          class="form-home"
          id="form"
          @submit.stop.prevent="onSubmit"
        >
          <div class="form-content" id="scrollhere">
            <input
              type="text"
              required
              name="nome"
              placeholder="Nome"
            />
            <input
              type="email"
              required
              name="email"
              placeholder="E-mail"
            />
            <input
              type="text"
              required
              name="telefone"
              placeholder="Telefone"
              v-mask="['(##) ####-####', '(##) #####-####']"
            />
            <select name="assunto">
              <option value="Lei geral de proteção de dados">
                Lei geral de proteção de dados
              </option>
              <option selected value="Assuntos gerais">
                Assuntos gerais
              </option>
            </select>
            <textarea
              name="mensagem"
              required
              placeholder="Mensagem"
              style="resize: none"
            />
            <b-button
              type="submit"
              :disabled="sendingForm"
              class="bt-enc mt-4"
            >
              <span v-if="!sendingForm">Enviar</span>
              <b-spinner
                v-else
                small
                variant="warning"
              ></b-spinner>
            </b-button>
          </div>
        </form> -->
        <b-row>
          <b-col cols="12">
            <div class="selos">
              <img src="../assets/images/footer.webp" alt="Selos de certificação e conformidade: ISO/IEC 27001 (Sistema de Gestão de Segurança da Informação), ISO/IEC 27701 (Sistema de Gestão da Privacidade da Informação), seguro AIG, e LGPD — Lei Geral de Proteção de Dados Pessoais." />
            </div>
          </b-col>
        </b-row>
        <a
          class="privacy-policy"
          target="_blank"
          href="https://enc-img.s3.sa-east-1.amazonaws.com/politica_de_privacidade.pdf"
        >
          Política de Privacidade
        </a>
        <p class="copy">
          © {{ (new Date()).getFullYear() }} ENC Interativa. Todos os direitos
          reservados.
        </p>
        <div class="bloco-redes">
          <div class="facebook-icon">
            <a
              class="text-center"
              style="text-decoration: none"
              href="https://www.facebook.com/encface"
              target="_blank"
              aria-label="Facebook da ENC Interativa (abre em nova aba)"
            >
              <b-icon icon="facebook"></b-icon>
            </a>
          </div>
          <div class="linkedin-icon">
            <a
              class="text-center"
              style="text-decoration: none"
              href="https://www.linkedin.com/company/enc-interativa/about/"
              target="_blank"
              aria-label="LinkedIn da ENC Interativa (abre em nova aba)"
            >
              <b-icon icon="linkedin"></b-icon>
            </a>
          </div>
        </div>
      </b-row>   
    </div>
  </footer>
</template>

<script>
import FormService from '../services/FormService';

export default {
  data() {
    return {
      sendingForm: false,
    };
  },
  mounted() {
    this.formService = new FormService();
  },
  methods: {
    openForm() {
      document
        .querySelector('.form-home')
        .classList.toggle('motion-in');
    },
    onSubmit() {
      this.sendingForm = true;
      const form = document.getElementById('form');
      const formData = new FormData(form);

      const res = Object.fromEntries(formData);

      this.formService.postForm(res).then(() => {
        this.openForm();
        form.reset();
        this.$vToastify.clientSuccess(
          'Mensagem enviada com sucesso!',
          'Sucesso'
        );
        this.sendingForm = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
@import '../assets/scss/global';
//FORM CONTATO HOME

.form-home {
  transition: all 0.5s ease-in-out;
  height: 0;
  opacity: 0;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 25px;
  border: 2px solid #f9c827;
  border-radius: 8px;
  max-width: 700px;
  width: 100%;
  color: #242424;
  margin: 0 auto;
  overflow: hidden;
  select {
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 5px auto;
    padding: 5px 10px;
    color: #242424bf;
    width: 100%;
  }

  input,
  textarea {
    min-height: 40px;
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin: 5px auto;
    padding: 5px 10px;
  }
  textarea {
    min-height: 200px;
  }
  button {
    margin: 0 auto !important;
    &:focus {
      box-shadow: none !important;
    }
    @media (max-width: 768px) {
      &:hover {
        background: transparent !important;
      }
    }
  }
  &.form-content {
    display: none;
  }
  &.motion-in {
    transition: all 0.5s ease-in-out;
    opacity: 1;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    margin: 2rem auto 1rem;
    height: 482px;
    &.form-content {
      transition: all 0.5s ease-in-out;
      display: block;
    }
  }
}

.spinner-border-sm {
  border-width: 0.2em !important;
}

.spinner-border {
  border: 0.15em solid currentColor !important;
  border-right-color: transparent !important;
}

//

.section {
  background-color: $white !important;
  height: 100% !important;
  padding-top: 50px !important;
  min-height: 342px !important;
}

.wrap {
  flex-flow: column !important;
  justify-content: center !important;
}

.selos {
  display: flex;
  justify-content: center;
  margin: 1.5rem auto;

  img {
    max-width: 560px;
    width: 100%;
    height: auto;
  }
}

.bloco-intes {
  display: flex;
  justify-content: space-evenly !important;
  align-items: center !important;
  max-width: 1200px !important;
}

.itens-footer {
  width: 249px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-direction: column !important;
  margin-bottom: 3.5rem;

  a {
    &:is(:hover, :focus-visible) {
      outline: none;
      p {
        background: $cor1;
        text-shadow: 0 0 0.8px $cor2, 0 0 0.8px $cor2, 0 0 0.8px $cor2;
      }
    }
    p {
      border-radius: 4px;
      padding: 2px 8px 1px;
      transition: background .3s ease;
    }
  }

  p {
    margin-top: 10px !important;
    text-align: center !important;
  }

  svg {
    width: 1.5rem !important;
    height: 1.5rem !important;
    fill: $cor1 !important;
  }
}

.copy {
  text-align: center !important;
  padding-top: 15px !important;
}

.privacy-policy {
  display: block;
  width: fit-content;
  margin: 0 auto;
  text-underline-offset: 3px;
  text-decoration-thickness: 1px;
  border-radius: 4px;
  padding: 4px 8px;
  transition: background .3s ease;
  &:is(:hover, :focus-visible) {
    outline: none;
    background: $cor1;
    text-shadow: 0 0 0.8px $cor2, 0 0 0.8px $cor2, 0 0 0.8px $cor2;
  }
}

.bloco-redes {
  display: flex !important;
  justify-content: space-evenly !important;
  align-items: center !important;
  max-width: 300px !important;
  width: 100% !important;
  margin: 0 auto !important;
  padding-top: 15px !important;

  svg {
    width: 1.5rem !important;
    height: 1.5rem !important;
    fill: $cor2 !important;
  }

  .facebook-icon {
    a:is(:hover, :focus-visible) {
      outline: none;
      transform: translateY(-5px) !important;
      transition: 0.3s !important;
      display: inline-block;

      svg {
        fill: #1877f2 !important;
      }
    }
  }

  .twitter-icon {
    a:is(:hover, :focus-visible) {
      outline: none;
      transform: translateY(-5px) !important;
      transition: 0.3s !important;
      display: inline-block;

      svg {
        fill: #2aa9e0 !important;
      }
    }
  }

  .linkedin-icon {
    a:is(:hover, :focus-visible) {
      outline: none;
      transform: translateY(-5px) !important;
      transition: 0.3s !important;
      display: inline-block;

      svg {
        fill: #2867b2 !important;
      }
    }
  }
}

@media (max-width: $mobile) {
  .selos img {
    max-width: 320px;
  }

  .bloco-intes {
    flex-direction: column !important;

    .itens-footer {
      flex-direction: row !important;
      padding-bottom: 10px !important;

      svg {
        margin: 7px 4px 0 0 !important;
      }
    }
  }
}
</style>